import { render, staticRenderFns } from "./MapIconSber.vue?vue&type=template&id=6beb49c1&scoped=true&"
import script from "./MapIconSber.vue?vue&type=script&lang=js&"
export * from "./MapIconSber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6beb49c1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6beb49c1')) {
      api.createRecord('6beb49c1', component.options)
    } else {
      api.reload('6beb49c1', component.options)
    }
    module.hot.accept("./MapIconSber.vue?vue&type=template&id=6beb49c1&scoped=true&", function () {
      api.rerender('6beb49c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/map/icons/MapIconSber.vue"
export default component.exports